<!--renewalDetail续保详情-->
<template>
  <group>
    <cell class="cou-cell">
      <p slot="after-title"><span class="cou-label">业务员：</span>{{orderData.offerer.name}}</p>
      <p slot="after-title"><span class="cou-label">客户类型：</span>{{orderData.car.insurance_rating}}</p>
      <p slot="after-title"><span class="cou-label">车牌号：</span>{{orderData.car.plate_number}}</p>
      <p slot="after-title"><span class="cou-label">续保金额：</span>￥{{orderData.quote_price | formatePrice}}</p>
      <p slot="after-title" class="mb50"><span class="cou-label">提交时间：</span>{{orderData.edited_at}}</p>
      <p slot="after-title" v-for="(v, i) in orderData.coupon_batches" :key="i">
        <em class="icon-price"></em>
        <em>{{v.title}},</em>
        <em v-if="v.face_value">价值{{v.face_value | formatePrice}}元,</em>
        <em v-html="v.issue_count"></em>张
      </p>
    </cell>
    <cell>
      <div slot="value">
        <a class="btn-pass-no" @click.stop="onCheck('reject')" v-if="orderData.status === 'pending_review'">审核不通过</a>&nbsp;&nbsp;
        <a class="btn-pass" @click.stop="onCheck('approve')" v-if="orderData.status === 'pending_review'">审核通过</a>
        <a class="btn-check-ok" v-else>{{statusTxt[orderData.status]}}</a>
      </div>
    </cell>
  </group>
</template>

<script>
import {
  Cell,
  Group
} from '@lx-frontend/cvux'
export default {
  components: {
    Cell,
    Group
  },
  data () {
    return {
      orderData: {
        offerer: {},
        car: {},
        coupon_batches: []
      },
      statusTxt: {
        pending_review: '待审核',
        review_rejected: '审核不通过',
        published: '审核通过',
        pending_payment: '待支付',
        paid: '已支付',
        finished: '已完成',
        closed: '关闭'
      }
    }
  },
  created () {
    this.loadList()
  },
  filters: {
    formatePrice(price) {
      return (price / 100).toFixed(2)
    }
  },
  methods: {
    loadList () {
      let quoteId = +this.$route.params.quote_id
      if (quoteId) {
        this.$rest.cou.checkList.insuranceQuotes(null, `${quoteId}/review`).then((res) => {
          if (res.code === 0) {
            this.orderData = res.data
          } else {
            this.showToast(res.message)
          }
        }, (res) => {
          if (res.status === 500) {
            // this.busy = true
          }
        })
      }
    },
    // 审核
    onCheck (action) {
      this.$rest.cou.checkRenewal({
        action: action
      }, `${this.orderData.quote_id}/review`).then(res => {
        if (res.code === 0) {
          if (action === 'reject') {
            this.orderData.status = 'review_rejected'
          } else if (action === 'approve') {
            this.orderData.status = 'published'
          }
        } else {
          this.showToast(res.message)
        }
      })
    }
  }
}
</script>

<style lang="less">
  @w2: 75rem;
  .cou-cell .weui_cell_primary p{
    p{
      line-height: 1.8;
      .cou-label{
        width: 228/@w2;
        display: inline-block;
        opacity: 0.4;
      }
    }
    .mb50{
      margin-bottom: 40/@w2;
    }
  }
</style>
